import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { DialogFeedbackComponent } from "../dialog-feedback/dialog-feedback.component";
import Feedback from "../../models/feedback.model";
import { FeedbackService } from "../../services/feedback.service";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-feedbacks",
  styleUrls: ["./view-feedbacks.component.scss"],
  templateUrl: "./view-feedbacks.component.html",
})
export class ViewFeedbacksComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "admin"; //admin / develop

  submitted = false;
  loading = false;
  cursor: any;
  done = false;

  display?: Feedback[] = [];
  feedbacks?: Feedback[] = [];

  pageSize = 3;
  strSearch = "";
  isMyLecture = false;
  uid = "anonymous";

  constructor(
    private feedbackService: FeedbackService,
    public userService: UserService,
    private dialogService: NbDialogService,
    private router: Router
  ) {}

  ngOnInit() {
    this.cursor = null;

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
        this.getFeedbacks();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMore(): void {
    this.pageSize = 12;
    this.getFeedbacks();
  }

  search() {
    this.strSearch = this.strSearch.toLowerCase();
  }

  close() {}

  //Control event lazyloading qna feedback
  onSearch(): void {
    const uid = this.isMyLecture ? this.uid : "";
    this.strSearch = this.strSearch.toLowerCase();

    this.display = this.feedbacks.filter(
      function (item) {
        return (
          (item.title.toLowerCase().includes(this.title) ||
            item.description.toLowerCase().includes(this.title)) &&
          (uid == "" || item.createdBy == uid)
        );
      },
      { title: this.strSearch }
    );
  }

  onNew() {
    let fbNew = new Feedback();
    fbNew.category = "Góp ý";

    this.dialogService
      .open(DialogFeedbackComponent, {
        context: {
          header: "Tạo bài viết",
          mode: "new",
          feedback: fbNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value && value.status == 1) {
          this.feedbacks = [value, ...this.feedbacks];
          this.display = [...this.feedbacks];
        }
      });
  }

  onEdit(item: Feedback) {
    if (item) {
      for (let i = 0; i < this.feedbacks.length; i++) {
        if (this.feedbacks[i].id == item.id) {
          this.feedbacks[i] = item;
          break;
        }
      }
      this.display = [...this.feedbacks];
    }
  }

  onDelete(value) {
    if (value) {
      remove(this.feedbacks, (e) => {
        return e.id == value;
      });
      this.display = [...this.feedbacks];
    }
  }

  private getFeedbacks(): void {
    this.loading = true;

    let subscribe: any;
    if (this.mode == "admin") {
      subscribe = this.feedbackService.getFeedbacks(this.pageSize, this.cursor);
    } else {
      subscribe = this.feedbackService.getMyFeedbacks(
        this.uid,
        this.pageSize,
        this.cursor
      );
    }

    subscribe
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            let data = new Feedback();
            data = doc.data();
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);

            let item = find(this.feedbacks, ["id", data.id]);
            if (item) {
              item = data;
            } else {
              this.feedbacks.push(data);
            }
          });

          this.display = [...this.feedbacks];
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        console.log("getFeedbacks/error:", error);
      });
  }
}
